<template>
    <o-form-select
        :options="options"
        :blank-option-text="nullName"
        text-field="name"
        dont-sort
        :value="value"
        @change="changed"
        value-field="value"
    >
    </o-form-select>
</template>

<script>
export default {
    name: "OBooleanSelect",
    model: {
        event: "change",
        prop: "value",
    },
    props: {
        value: { type: Boolean, default: null },
        trueName: { type: String, default: "Yes" },
        falseName: { type: String, default: "No" },
        nullName: { type: String, default: "" },
    },
    methods: {
        changed(value) {
            this.$emit("change", value);
        },
    },
    computed: {
        options() {
            return [
                { value: null, name: this.nullName },
                { value: true, name: this.trueName },
                { value: false, name: this.falseName },
            ];
        },
    },
};
</script>

<style scoped></style>
